// @ts-nocheck
// Other
import { inject, observer } from 'mobx-react'
import React, { memo, useEffect, useState } from 'react'
import { WorkPageWrapper } from '../ManagementAssetWarehouseStylePage'
import DashboardLayout from '../../../layouts/DashboardLayout'
import { Helmet } from 'react-helmet'
import PageTitle from '../../../components/PageTitle'
import AppPageHeader from '../../../components/AppPageHeader'
import AccessControlAction from '../../../components/AccessControlAction'
import { Button, DatePicker, Menu, message } from 'antd'
import {
  FileExcelOutlined,
  VerticalAlignMiddleOutlined,
} from '@ant-design/icons'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import ContentBlockWrapper from '../../../components/ContentBlockWrapper'
import AssetStatisticsTable from './AssetInputTable'
import moment from 'moment'
import queryString from 'query-string'
import { useLocation, withRouter } from 'react-router-dom'
import { ACL_ACTION_TYPE, PROPOSAL_STATUS } from '../../../constants'

const AssetInputPage = props => {
  const { managementAssetWarehouseStore, authenticationStore, history } = props
  const { isAccountAdmin, currentUser } = authenticationStore
  const [isDisplaySummary, setIsDisplaySummary] = useState(false)
  const [assetInputList, setAssetInputList] = useState([])
  const [quantitySum, setQuantitySum] = useState(0)
  const [preMoneySum, setPreMoneySum] = useState(0)
  const [taxMoneySum, setTaxMoneySum] = useState(0)
  const [totalMoneySum, setTotalMoneySum] = useState(0)
  const [isLoadingSummary, setIsLoadingSummary] = useState(false)
  const [currentDate, setCurrentDate] = useState(
    moment(new Date()).format('MM-YYYY')
  )
  const location = useLocation()
  const queryStringParse = queryString.parse(location.search)
  const [isLoading, setIsLoading] = useState(false)
  const { pageIndex, sizeIndex } = managementAssetWarehouseStore

  useEffect(() => {
    if (queryStringParse.currentDate) {
      setCurrentDate(queryStringParse.currentDate)
    }
  }, [queryStringParse])
  useEffect(() => {
    if (isAccountAdmin) {
      setIsDisplaySummary(true)
    } else {
      setIsDisplaySummary(false)
    }
  }, [isAccountAdmin, currentUser])

  const handleChangeParams = params => {
    const queryStringStringify = queryString.stringify({
      ...queryStringParse,
      // page: 0,
      size: 10,
      ...params,
    })
    history.replace(`/manager-inventory/input?${queryStringStringify}`)
  }

  const onChange = (date, dateString) => {
    setCurrentDate(dateString)
    handleChangeParams({ currentDate: dateString })
  }

  useEffect(() => {
    ;(async () => {
      await loadManagerInventoryList()
    })()
  }, [pageIndex, sizeIndex, currentDate])

  const loadManagerInventoryList = () => {
    managementAssetWarehouseStore
      .getAssetInputList({
        monthYear: currentDate,
        page: 0,
        size: 999999,
      })
      .then(respose => {
        const list = respose?.data?.data
        setAssetInputList(list)
        if (list?.length > 0) {
          setQuantitySum(
            list?.reduce((sum, item) => {
              sum += Number(item.quantity)
              return sum
            }, 0)
          )
          setPreMoneySum(
            list?.reduce((sum, item) => {
              sum += Number(item.preMoney)
              return sum
            }, 0)
          )
          setTaxMoneySum(
            list?.reduce((sum, item) => {
              sum += Number(item.totalMoney) - Number(item.preMoney)
              return sum
            }, 0)
          )
          setTotalMoneySum(
            list?.reduce((sum, item) => {
              sum += Number(item.totalMoney)
              return sum
            }, 0)
          )
        } else {
          setPreMoneySum(0)
          setTaxMoneySum(0)
          setTotalMoneySum(0)
        }
      })
      .catch(err => {
        console.log(err)
      })
  }
  return (
    <WorkPageWrapper>
      <DashboardLayout>
        <Helmet>
          <title>Hành chính | Quản lý kho | Tài sản</title>
        </Helmet>

        <AppPageHeader
          title="Thống kê tài sản"
          addon={
            <AccessControlAction
              aclActionType={ACL_ACTION_TYPE.edit__PROPOSAL_ASSET}
              check={true}>
              <>
                <DatePicker
                  onChange={onChange}
                  className="h-40"
                  picker="month"
                  format="MM-YYYY"
                  value={moment(currentDate, 'MM-YYYY')}
                  defaultValue={moment(currentDate, 'MM-YYYY')}
                  style={{ width: '220px' }}
                />
                {isDisplaySummary && (
                  <Button
                    className="custom-ant-button"
                    loading={isLoadingSummary}
                    onClick={() => summary()}>
                    Tổng kết
                  </Button>
                )}
              </>
            </AccessControlAction>
          }
        />
        <ContentBlockWrapper>
          <div>
            <div className="text-16 font-weight-500 mb-10">
              Tổng hợp danh sách Số lượng: {quantitySum?.toLocaleString()},
              Tổng: {preMoneySum?.toLocaleString()}, thuế:{' '}
              {taxMoneySum?.toLocaleString()}, sau thuế:{' '}
              {totalMoneySum?.toLocaleString()}
            </div>
          </div>
          <AssetStatisticsTable
            isLoading={isLoading}
            currentDate={currentDate}
            handleChangeParams={handleChangeParams}
            reloadList={loadManagerInventoryList}
            assetStatisticList={assetInputList}
          />
        </ContentBlockWrapper>
      </DashboardLayout>
    </WorkPageWrapper>
  )
}

export default memo(
  withRouter(
    inject(
      'managementAssetWarehouseStore',
      'authenticationStore'
    )(observer(AssetInputPage))
  )
)
